var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalShow
    ? _c("div", { staticClass: "h-vertical-align-container" }, [
        _c("div", {
          staticClass: "modal__close",
          on: {
            click: function($event) {
              _vm.closeModal()
            }
          }
        }),
        _c("div", {
          staticClass: "modal__overlay",
          on: {
            click: function($event) {
              _vm.closeModal()
            }
          }
        }),
        _c(
          "div",
          {
            staticClass: "modal__wrapper modal__wrapper--buyModal",
            attrs: { id: "modalWrapper" }
          },
          [
            _vm.modalForm
              ? _c(
                  "div",
                  { staticClass: "modal__object", attrs: { id: "modalForm" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "modal-content modal--product modal__product--form"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "modal__container" },
                          [
                            _c("div", { staticClass: "message__container" }, [
                              _vm.success
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "message success",
                                      attrs: { id: "successMessage" }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "An e-mail has been sent to " +
                                            _vm._s(_vm.userInfo.identifier)
                                        )
                                      ]),
                                      _c("a", {
                                        staticClass: "close",
                                        on: {
                                          click: function($event) {
                                            _vm.hideSuccessMessage()
                                          }
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm.error
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "message error",
                                      attrs: { id: "errorMessage" }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.errorMessage))
                                      ]),
                                      _c("a", {
                                        staticClass: "close",
                                        on: {
                                          click: function($event) {
                                            _vm.hideErrorMessage()
                                          }
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ]),
                            _vm.forgotPassword ? _c("forget-pass") : _vm._e(),
                            _vm.registrationForm ? _c("register") : _vm._e(),
                            _vm.loginForm ? _c("login") : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7ed7f52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7ed7f52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buyModal.vue
// module id = null
// module chunks = 